var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filters" },
    [
      _vm.sizeFilter
        ? _c(
            "div",
            { staticClass: "filters__filter" },
            [
              _c("size-filter", {
                attrs: {
                  name: _vm.sizeFilter.id,
                  placeholder: _vm.sizeFilter.name,
                  options: _vm.sizeFilter.values,
                  value: _vm.sizeFilterValue
                },
                on: {
                  apply: function($event) {
                    return _vm.applyCategoryFilter({ filterData: [$event] })
                  },
                  clear: _vm.clearAppliedFilter
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.colorFilter
        ? _c(
            "div",
            { staticClass: "filters__filter" },
            [
              _c("color-filter", {
                attrs: {
                  name: _vm.colorFilter.id,
                  placeholder: _vm.colorFilter.name,
                  options: _vm.colorFilter.values,
                  value: _vm.colorFilterValue
                },
                on: {
                  apply: function($event) {
                    return _vm.applyCategoryFilter({ filterData: [$event] })
                  },
                  clear: _vm.clearAppliedFilter
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.priceFilter
        ? _c(
            "div",
            { staticClass: "filters__filter" },
            [
              _c("price-filter", {
                attrs: {
                  name: _vm.priceFilter.id,
                  placeholder: _vm.priceFilter.name,
                  options: _vm.priceFilter.values,
                  value: _vm.priceFilterValue
                },
                on: {
                  apply: function($event) {
                    return _vm.applyCategoryFilter({ filterData: [$event] })
                  },
                  clear: _vm.clearAppliedFilter
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("ui-button", {
        staticClass: "filters__all-filters",
        attrs: {
          secondary: "",
          text: _vm.filtersButtonTitle,
          count: _vm.appliedFiltersCount,
          icon: _vm.$options.icons.IconFilter.id,
          value: _vm.priceFilterValue
        },
        on: { click: _vm.showFiltersPanel }
      }),
      _vm.appliedFiltersCount
        ? _c(
            "button",
            {
              staticClass: "filters__clear",
              on: { click: _vm.clearAllAppliedFilters }
            },
            [_vm._v("\n    Сбросить\n  ")]
          )
        : _vm._e(),
      _c("category-sort", {
        staticClass: "filters__sort",
        attrs: { value: _vm.sort },
        on: {
          "sort-change": function($event) {
            return _vm.applyCategoryFilter({ sort: $event })
          }
        }
      }),
      _c("filters-drawer", {
        attrs: { "is-opened": _vm.isShownFiltersPanel },
        on: {
          close: function($event) {
            _vm.isShownFiltersPanel = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }